import type { EducationSystemConfig, AcademicLevel } from "./types";

export const educationSystems: EducationSystemConfig[] = [
  {
    id: "india",
    name: "India",
    description: "CBSE, ICSE, State Boards, JEE, NEET, and other Indian curricula",
    levels: [
      "class-1",
      "class-2",
      "class-3",
      "class-4",
      "class-5",
      "class-6",
      "class-7",
      "class-8",
      "class-9",
      "class-10",
      "class-11",
      "class-12",
      "jee-foundation",
      "jee-main",
      "jee-advanced",
      "neet",
      "state-competitive",
      "undergraduate",
      "postgraduate",
      "advanced",
    ],
  },
  {
    id: "us",
    name: "United States",
    description: "Common Core, AP, College/University mathematics",
    levels: [
      "elementary",
      "middle-school",
      "grade-9",
      "grade-10",
      "grade-11",
      "grade-12",
      "ap-level",
      "college",
      "graduate",
    ],
  },
  {
    id: "general",
    name: "General / No Specific Curriculum",
    description: "Topic-based selection without curriculum constraints",
    levels: [
      "elementary",
      "middle-school",
      "grade-9",
      "college",
      "graduate",
      "advanced",
    ],
  },
];

export function getEducationSystem(id: string): EducationSystemConfig | undefined {
  return educationSystems.find((s) => s.id === id);
}

export function getLevelsForSystem(systemId: string): AcademicLevel[] {
  const system = getEducationSystem(systemId);
  return system?.levels ?? [];
}

export function getEducationSystemNames(): { id: string; name: string }[] {
  return educationSystems.map((s) => ({ id: s.id, name: s.name }));
}